import { FileText } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function PDFtoWord() {
  const { t } = useLanguage();
  const tk = t.tools.pdfToWord;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/pdf-to-word",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#16a34a",
    Icon: FileText,
    toolKey: "pdfToWord",
  };

  return <ToolPage config={config} />;
}
